























import { Component, Prop, Vue } from 'vue-property-decorator';
import { SelectorButton, HumIcon, CalendarIcon } from './components';
import { ISelector } from './types';

@Component({
  components: {
    SelectorButton,
    CalendarIcon,
    HumIcon,
  },
})
export default class Selector extends Vue implements ISelector {
  @Prop({ type: Boolean, default: false })
  readonly isNoDate!: boolean;

  toggleActive: boolean = true;

  get bgColorStyle() {
    const { colorMenuMain } = this.$store.state.regionProfile;
    if (!colorMenuMain) return '';
    return colorMenuMain;
  }

  selected(value: number) {
    this.toggleActive = !this.toggleActive;
    this.$emit('selected', value);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/remote-edu/calendar/components/selector/Selector.vue